import * as React from "react";

import { nullElement } from "../../TypingUtils";

import { useTable2MultirowDisplayIndex, useTable2MultirowInstanceCount } from "./Table2Multirow";

interface Table2VerticalColumnProps {
    children: React.ReactNode[];
}

export function Table2VerticalColumn(props: Table2VerticalColumnProps): null | JSX.Element {
    const multirowInstanceCount = useTable2MultirowInstanceCount();
    const displayIndex = useTable2MultirowDisplayIndex();
    if (displayIndex > 0) {
        return nullElement;
    }
    return <td rowSpan={multirowInstanceCount}>{props.children}</td>;
}
